import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGridInterface2Line = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M3.99076 3.89729C4.97547 2.84115 6.37768 2.25 8.03313 2.25H16.4678C18.1272 2.25 19.5296 2.84086 20.5134 3.89773C21.4916 4.94853 22 6.39899 22 8.02638V15.9736C22 17.601 21.4916 19.0515 20.5133 20.1023C19.5293 21.1592 18.1266 21.75 16.4669 21.75H8.03313C6.37379 21.75 4.97117 21.1592 3.98714 20.1024C3.00872 19.0516 2.5 17.6011 2.5 15.9736V8.02638C2.5 6.39795 3.01147 4.9476 3.99076 3.89729ZM5.08786 4.9202C4.41042 5.64678 4 6.70962 4 8.02638V15.9736C4 17.2913 4.40879 18.354 5.08492 19.0802C5.75542 19.8003 6.74437 20.25 8.03313 20.25H16.4669C17.7562 20.25 18.7451 19.8002 19.4154 19.0802C20.0914 18.3541 20.5 17.2914 20.5 15.9736V8.02638C20.5 6.70857 20.0914 5.64585 19.4155 4.91976C18.7452 4.19973 17.7566 3.75 16.4678 3.75H8.03313C6.74924 3.75 5.75988 4.19944 5.08786 4.9202Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12.25 2.25C12.6642 2.25 13 2.58579 13 3V21C13 21.4142 12.6642 21.75 12.25 21.75C11.8358 21.75 11.5 21.4142 11.5 21V3C11.5 2.58579 11.8358 2.25 12.25 2.25Z",
		fill: "currentColor"
	})]
});
export default SvgGridInterface2Line;
